import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const host = window.location.hostname;
if (host.includes('firebaseapp.com') || host.includes('web.app') || host.includes('flow.quality.com.br')) {
  const newUrl = 'https://gestaoquality.com.br' + window.location.pathname + window.location.search;
  document.body.innerHTML = `
    <div style="margin: 0; padding: 0; background-color: #f4f7f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; display: flex; align-items: center; justify-content: center; height: 100vh; color: #333;">
      <div style="background: #fff; padding: 40px; border-radius: 12px; box-shadow: 0 10px 25px rgba(0,0,0,0.05); max-width: 500px; width: 90%; text-align: center;">
        <h1 style="color: #00897b; margin-top: 0; font-size: 26px;">Mudamos de Endereço! 🚀</h1>
        <p style="font-size: 16px; line-height: 1.5; color: #555;">O nosso sistema de gestão agora tem um novo link oficial.<br>Por favor, <strong>atualize os seus favoritos</strong> para:</p>
        <a href="${newUrl}" style="display: inline-block; background-color: #00897b; color: #fff; padding: 14px 28px; border-radius: 8px; text-decoration: none; font-weight: bold; font-size: 18px; margin: 20px 0; box-shadow: 0 4px 6px rgba(0,137,123,0.3);">gestaoquality.com.br</a>
        <p style="font-size: 14px; color: #888; margin-bottom: 0;">Você será redirecionado em <strong id="cd">5</strong> segundos...</p>
      </div>
    </div>
  `;
  let c = 5;
  setInterval(() => { c--; if(document.getElementById('cd')) document.getElementById('cd').innerText = c; }, 1000);
  setTimeout(() => { window.location.replace(newUrl); }, 5000);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}
